// Copyright (c) 2026 Goffy. All Rights Reserved.

/**
 * The start hole as the BFF sends it on round.state, round.updated and hole.update frames:
 * `startHoleNumber` (camelCase from the listeners, PascalCase from older payloads), a positive
 * integer, or absent while the round has no score yet. Anything else reads as "unknown", so a
 * malformed frame can never move the play order.
 */
export const readStartHoleNumber = (frame: unknown): number | undefined => {
  if (!frame || typeof frame !== 'object') return undefined;
  const raw =
    (frame as { startHoleNumber?: unknown }).startHoleNumber ??
    (frame as { StartHoleNumber?: unknown }).StartHoleNumber;
  return typeof raw === 'number' && Number.isInteger(raw) && raw >= 1 ? raw : undefined;
};
